<div class="auth-page-container container" id="auth-page-container">
	<cpi-msp-semantix-logo></cpi-msp-semantix-logo>

	@if (pageView === 'login' || pageView === 'password-reset') {
		@if (!isLoadingLabels && !isCheckingRedirect) {
			<div class="login-container">
				@if (pageView === 'login') {
					<input
						[ngClass]="{ 'not-empty': username.trim() !== '' }"
						type="text"
						id="login"
						[(ngModel)]="username"
						(keydown)="verifyInput($event)" />
					<label for="login">{{ labels.lbl_geral_login }}</label>

					<input
						type="password"
						[ngClass]="{ 'not-empty': password.trim() !== '' }"
						id="password"
						[(ngModel)]="password"
						(keydown)="verifyInput($event)" />
					<label for="password">{{ labels.lbl_geral_senha }}</label>

					<div>
						<span class="forgot-password" (click)="pageView = 'password-reset'">{{ labels.lbl_geral_esqueci_senha }}</span>
					</div>

					<div class="button-container">
						<div class="button" (click)="login()">
							{{ labels.lbl_geral_login }}
						</div>
					</div>
				}

				@if (pageView === 'password-reset') {
					<input type="text" id="loginReset" [(ngModel)]="username" />
					<label for="loginReset">{{ labels.lbl_geral_email }}</label>

					<div>
						<span class="forgot-password" (click)="pageView = 'login'">{{ labels.lbl_geral_voltar }}</span>
					</div>

					<div class="buttons-container">
						<div class="button" (click)="requestResetPassword()">
							{{ labels.lbl_solicitar_reset }}
						</div>
					</div>
				}

				<div class="alert-container" [ngClass]="{ tremb: this.isAlertVisible }">{{ alertMessage }}</div>
			</div>
		}
	}
</div>

<img class="blue-login-ball" src="assets/images/BolinhaAzul.svg" />
<img class="orange-login-ball" src="assets/images/BolinhaRosa.svg" />
